import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';

gsap.registerPlugin(ScrollTrigger);

const Manifesto = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRefs = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Title reveal
      if (titleRef.current) {
        const split = new SplitType(titleRef.current, { types: 'words' });
        gsap.from(split.words, {
          scrollTrigger: {
            trigger: titleRef.current,
            start: 'top 80%',
          },
          y: 50,
          opacity: 0,
          stagger: 0.05,
          duration: 0.8,
          ease: 'power3.out',
        });
      }

      // Text reveals
      textRefs.current.forEach((text, index) => {
        if (text) {
          gsap.from(text, {
            scrollTrigger: {
              trigger: text,
              start: 'top 85%',
            },
            y: 40,
            opacity: 0,
            duration: 0.8,
            delay: index * 0.1,
            ease: 'power2.out',
          });
        }
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-24 lg:py-32 px-8"
      style={{ backgroundColor: 'var(--atelier-cream)' }}
    >
      <div className="max-w-4xl mx-auto text-center">
        <div className="w-24 h-px bg-[var(--atelier-gold)] mx-auto mb-12" />
        
        <h2
          ref={titleRef}
          className="text-5xl md:text-7xl font-light mb-16"
          style={{ color: 'var(--atelier-black)', lineHeight: 1.2 }}
        >
          Wij geloven in verwennen.
        </h2>

        <div className="space-y-8">
          <p
            ref={(el) => (textRefs.current[0] = el)}
            className="text-2xl md:text-3xl font-light"
            style={{ color: 'var(--atelier-grey)' }}
          >
            In de zondagochtend met verse croissants.
          </p>
          <p
            ref={(el) => (textRefs.current[1] = el)}
            className="text-2xl md:text-3xl font-light"
            style={{ color: 'var(--atelier-grey)' }}
          >
            In de geur van warme pannenkoeken.
          </p>
          <p
            ref={(el) => (textRefs.current[2] = el)}
            className="text-2xl md:text-3xl font-light"
            style={{ color: 'var(--atelier-grey)' }}
          >
            In het moment dat je de pot opendraait en even stilstaat.
          </p>
        </div>

        <div className="mt-16">
          <p
            ref={(el) => (textRefs.current[3] = el)}
            className="text-3xl md:text-4xl font-light"
            style={{ color: 'var(--atelier-gold)' }}
          >
            Penotti Atelier. Voor wie meer verwacht.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;